import { toURLSearchParams } from '@wix/sdk-runtime/rest-modules';
import { transformRESTTimestampToSDKTimestamp } from '@wix/sdk-runtime/transformations/timestamp';
import { transformPaths } from '@wix/sdk-runtime/transformations/transform-paths';
import { resolveUrl } from '@wix/sdk-runtime/rest-modules';
import { ResolveUrlOpts } from '@wix/sdk-runtime/rest-modules';
import { RequestOptionsFactory } from '@wix/sdk-types';

function resolveComWixpressMarketAimApiAppInstanceServiceUrl(
  opts: Omit<ResolveUrlOpts, 'domainToMappings'>
) {
  const domainToMappings = {
    'api._api_base_domain_': [
      {
        srcPath: '/app-instance-manager-webapp',
        destPath: '',
      },
    ],
    'www.wixapis.com': [
      {
        srcPath: '/apps',
        destPath: '',
      },
    ],
    'wixapis.com': [
      {
        srcPath: '/apps',
        destPath: '',
      },
    ],
    'dev._base_domain_': [
      {
        srcPath: '/_api/app-instance-manager',
        destPath: '',
      },
      {
        srcPath: '/api/v1/instance',
        destPath: '/v1/instance',
      },
      {
        srcPath: '/api/v1/scripts',
        destPath: '/v1/scripts',
      },
    ],
    'manage._base_domain_': [
      {
        srcPath: '/_api/app-instance-manager',
        destPath: '',
      },
    ],
    'www._base_domain_': [
      {
        srcPath: '/_api/app-instance-manager',
        destPath: '',
      },
    ],
    'editor._base_domain_': [
      {
        srcPath: '/_api/app-instance-manager',
        destPath: '',
      },
    ],
    'blocks._base_domain_': [
      {
        srcPath: '/_api/app-instance-manager',
        destPath: '',
      },
    ],
    'create.editorx': [
      {
        srcPath: '/_api/app-instance-manager',
        destPath: '',
      },
    ],
    '*.dev.wix-code.com': [
      {
        srcPath: '/devcenter/app-instance/v1/instance',
        destPath: '/v1/instance',
      },
      {
        srcPath: '/devcenter/checkout/v1/checkout',
        destPath: '/v1/checkout',
      },
      {
        srcPath: '/devcenter/checkout/v1/metered-billing-charges',
        destPath: '/v1/metered-billing-charges',
      },
      {
        srcPath: '/devcenter/scripts/v1/scripts',
        destPath: '/v1/scripts',
      },
      {
        srcPath: '/market/aim/v1/billing-event',
        destPath: '/v1/billing-event',
      },
      {
        srcPath: '/devcenter/bi-events/v1/bi-event',
        destPath: '/v1/bi-event',
      },
    ],
    _: [
      {
        srcPath: '/devcenter/app-instance/v1/instance',
        destPath: '/v1/instance',
      },
      {
        srcPath: '/devcenter/checkout/v1/checkout',
        destPath: '/v1/checkout',
      },
      {
        srcPath: '/devcenter/checkout/v1/metered-billing-charges',
        destPath: '/v1/metered-billing-charges',
      },
      {
        srcPath: '/devcenter/scripts/v1/scripts',
        destPath: '/v1/scripts',
      },
      {
        srcPath: '/market/aim/v1/billing-event',
        destPath: '/v1/billing-event',
      },
      {
        srcPath: '/devcenter/bi-events/v1/bi-event',
        destPath: '/v1/bi-event',
      },
    ],
  };

  return resolveUrl(Object.assign(opts, { domainToMappings }));
}

const PACKAGE_NAME = '@wix/auto_sdk_app-management_app-instances';

/**
 * Retrieves data about the instance of your app that's installed on a Wix
 * site and data about the site itself. For example, to check whether the Wix user has installed a free or paid version of your app,
 * or to check which apps made by Wix are installed on the site.
 *
 * You must authenticate this method [as a Wix app](https://dev.wix.com/docs/build-apps/develop-your-app/access/authentication/authenticate-using-oauth#step-2--make-an-authenticated-api-request).
 *
 * To retrieve `site.ownerInfo` in the response, you must
 * have the __READ SITE OWNER EMAIL__ permission scope in addition to
 * __MANAGE YOUR APP__.
 */
export function getAppInstance(payload: object): RequestOptionsFactory<any> {
  function __getAppInstance({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.devcenter.app_instance.v1.app_instance',
      method: 'GET' as any,
      methodFqn:
        'com.wixpress.market.aim.api.AppInstanceService.GetAppInstance',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixpressMarketAimApiAppInstanceServiceUrl({
        protoPath: '/v1/instance',
        data: payload,
        host,
      }),
      params: toURLSearchParams(payload),
      transformResponse: (payload: any) =>
        transformPaths(payload, [
          {
            transformFn: transformRESTTimestampToSDKTimestamp,
            paths: [{ path: 'instance.billing.freeTrialInfo.endDate' }],
          },
        ]),
    };

    return metadata;
  }

  return __getAppInstance;
}
